<div class="cob-dialog-wrapper m-24">
	<div class="flex flex-col">
		<div class="flex flex-row w-100-percent pl-6">
			<div class="flex flex-col basis-full">
				 <div [ngSwitch]="data?.title" class="fw-700 mat-headline-5 fs-20">
          <div *ngSwitchCase="'configPack'">{{ 'ERRORS.CONFIGURATION_PACKAGE' | transloco }}</div>
          <div *ngSwitchCase="'envPack'">{{ 'ERRORS.ENVIRONMENT_PACKAGE' | transloco }}</div>
        </div>
				<div class="fs-16 fw-500">{{ data?.jarName}}</div>
			</div>
      <div class="flex flex-col mr-24">
        <button class="flex justify-end h-30 pt-4 pr-8 pb-4 pl-8 download" (click)="downloadJson()">
            <span class="fs-16 fw-500 item flex items-center">
                <mat-icon class="h-18 w-18 mr-6" svgIcon="file_download"></mat-icon>
                {{ 'ERRORS.DOWNLOAD' | transloco }}
            </span>
        </button>
    </div>
      <div class="flex flex-col mr-24">
				<button class="flex justify-end h-30 error-copy-class pt-4 pr-8 pb-4 pl-8"
					[ngClass]="[copy ? 'copied': 'copy']" (click)="copyText()">
					<span *ngIf="!copy" class="fs-16 fw-500 item flex items-center">
						<mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERRORS.COPY' |
						transloco }}
					</span>
					<span *ngIf="copy" class="fs-16 fw-500 item flex items-center copied-text">
						<mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERRORS.COPIED' | transloco
						}}
					</span>
				</button>
			</div>
			<div class="flex flex-col mr-6">
        <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
			</div>
		</div>
		<mat-divider class="w-100-percent mt-16 mb-16 mat-divider"></mat-divider>
    <div class="flex flex-col packageContent mb-8">
      <div class="ml-12 mr-12 mb-20" *ngFor="let error of data?.description; let last = last">
        <div class="mb-8 fs-14 fw-400" *ngIf="error.code">
          <span class="error-text">"{{ 'ERRORS.CODE' | transloco }}": </span>
          <span>"{{ error.code }}"</span>
        </div>
        <div class="mb-8 fs-14 fw-400" *ngIf="error.component">
          <span class="error-text">"{{ 'ERRORS.COMPONENT' | transloco }}": </span>
          <span>"{{ error.component }}"</span>
        </div>
        <div class="mb-8 fs-14 fw-400" *ngIf="error.fieldName">
          <span class="error-text">"{{ 'ERRORS.FIELDNAME' | transloco }}": </span>
          <span>"{{ error.fieldName }}"</span>
        </div>
        <div class="mb-8 fs-14 fw-400" *ngIf="error.message">
          <span class="error-text">"{{ 'ERRORS.MESSAGE' | transloco }}": </span>
          <span>"{{ error.message }}"</span>
        </div>
        <div class="mb-8 fs-14 fw-400" *ngIf="error.type">
          <span class="error-text">"{{ 'ERRORS.TYPE' | transloco }}": </span>
          <span>"{{ error.type }}"</span>
        </div>
        <mat-divider *ngIf="!last" class="w-100-percent mt-16 mb-16 mat-divider-inner"></mat-divider>
      </div>
    </div>
    <mat-divider class="w-100-percent mt-8 mb-8 mat-divider"></mat-divider>

    <div class="flex flex-row justify-center items-center mt-8 mb-8 ml-auto">
      <button class="white mr-20 report-letter-spacing" type="button" (click)="matdialogRef.close()"> {{ 'ERRORS.BACK' | transloco }} </button>
      <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{ 'ERRORS.REPORT' | transloco }} </button>
    </div>
	</div>
</div>